module.exports = __webpack_public_path__ + "img/reports-section.21f5dc26.svg";